import { render, staticRenderFns } from "./TransitionCollapse.vue?vue&type=template&id=3d796440&"
import script from "./TransitionCollapse.vue?vue&type=script&lang=js&"
export * from "./TransitionCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports